<template>
  <div class="index">
    <div class="productions">
      <div class="mile_Productions">
        <img src="../assets/image/banner.png" alt />
        <!-- <h3>8 MILE</h3>
        <div>2019/2020<br>赛季强势开启！  <br>BUILD HIPHOP DREAM  <br> /////////////////////</div>-->
      </div>
      <div class="login" v-if="show">
        <el-form
          v-if="loginType"
          ref="loginForm"
          :model="loginForm"
          :rules="loginRules"
          class="login-form"
          auto-complete="on"
          label-position="left"
        >
          <div class="logins">
            <h3 class="title">后 台 管 理 系 统</h3>
            <el-form-item
              prop="account"
              style="width: 250px;margin: 0 auto;background: #fff;border-radius:10px;"
            >
              <div class="svg-container">
                <img src="../assets/image/user.png" alt />
              </div>
              <el-input
                @keyup.enter.native="handleLogin"
                v-model="loginForm.account"
                name="username"
                type="text"
                auto-complete="on"
                placeholder="请输入账号"
              />
            </el-form-item>
            <el-form-item
              prop="password"
              style="width: 250px;margin: 20px auto;background: #fff;border-radius:10px;"
            >
              <span class="svg-container">
                <img src="../assets/image/password.png" alt />
              </span>
              <el-input
                :type="pwdType"
                v-model="loginForm.password"
                name="password"
                placeholder="请输入密码"
                @keyup.enter.native="handleLogin"
              />
              <span class="show-pwd" @click="showPwd"></span>
            </el-form-item>
            <el-form-item
              prop="yzcode"
              style="width: 250px;margin: 0 auto;background: #fff;border-radius:10px;position: relative"
            >
              <span class="svg-container">
                <img src="../assets/image/yzm.png" alt />
              </span>
              <div class="yzcode" style="width: 120px;display: inline-block">
                <el-input
                  @keyup.enter.native="handleLogin"
                  v-model="loginForm.imgCode"
                  name="yzcode"
                  type="text"
                  auto-complete="on"
                  placeholder="验证码"
                />
              </div>
              <div style="width: 85px;display: inline-block;">
                <Identify :identifyCode="code" />
              </div>
              <img
                src="../assets/image/sx.png"
                class="sx"
                :style="{transform:'rotateZ('+deg+'deg)'}"
                icon-class="refresh"
                @click="refresh()"
              />
            </el-form-item>
            <el-form-item>
              <div
                class="title"
                style="margin: 30px auto 0px auto;cursor: pointer"
                @keyup.enter.native="handleLogin"
                @click="handleLogin"
              >登录</div>
            </el-form-item>
            <!--<div class="tips">-->
            <!--<span style="margin-right:20px;">username: admin</span>-->
            <!--<span> password: admin</span>-->
            <!--</div>-->
          </div>
        </el-form>
        <div class="qcode" v-else>
          <h3 class="title">后 台 管 理 系 统</h3>
          <div style="width: 200px;height: 200px;margin: 0 auto;border: 1px solid #D0D0D0">
            <qriously style="margin: 10px" value="https://www.baidu.com/" :size="180" />
          </div>
          <div style="text-align: center;padding-bottom: 20px;padding-top: 5px">
            请使用
            <a
              target="_blank"
              href="https://mo.baidu.com/wuxian/?from=1019447z"
              style="color:#a3f310 ;"
            >八英里App</a>扫码登录
          </div>
        </div>
        <!--<div class="switch" @click="switchs()">{{loginType?'扫码登录':'账号密码登录'}}</div>-->
      </div>
    </div>
    <div class="foot-bg">
      <img style="width: 100%;" src="../assets/image/f-bg.png" alt />
    </div>
  </div>
</template>

<script>
import { getCode } from "@/api/login";
import { isvalidUsername } from "@/utils/validate";
import Identify from "../components/identify.vue";
export default {
  name: "index",
  components: { Identify },
  created() {
    this.getCode();
    if (
      this.$store.state.user.name &&
      this.$store.state.user.name != "" &&
      this.$store.state.user.name != null
    ) {
      this.show = false;
    } else {
      this.show = true;
    }
  },
  data() {
    const validateAccount = (rule, value, callback) => {
      if (value == "") {
        callback(new Error("请输入用户名"));
      } else {
        callback();
      }
    };
    const validatePass = (rule, value, callback) => {
      if (value.length < 5) {
        callback(new Error("密码不能小于5位"));
      } else {
        callback();
      }
    };
    return {
      code: "",
      show: false,
      loginForm: {
        account: "",
        password: "",
        imgCode: "",
      },
      loginRules: {
        account: [
          { required: true, trigger: "change", validator: validateAccount },
        ],
        password: [
          { required: true, trigger: "change", validator: validatePass },
        ],
      },
      loginType: true,
      loading: false,
      pwdType: "password",
      redirect: undefined,
      deg: 0,
    };
  },
  watch: {
    $route: {
      handler: function (route) {
        this.redirect = route.query && route.query.redirect;
      },
      immediate: true,
    },
  },
  methods: {
    switchs() {
      this.loginType = !this.loginType;
    },
    getCode() {
      getCode().then((response) => {
        this.code = response.data;
      });
    },
    refresh() {
      this.deg += 180;
      this.getCode();
    },
    showPwd() {
      if (this.pwdType === "password") {
        this.pwdType = "";
      } else {
        this.pwdType = "password";
      }
    },
    handleLogin() {
      this.$refs.loginForm.validate((valid) => {
        if (valid) {
          this.loading = true;
          const loading = this.$loading({
            lock: true,
            text: "登录中",
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)",
          });
          this.loginForm.imageCodeStr = this.code;
          this.$store
            .dispatch("Login", this.loginForm)
            .then((res) => {
              this.loading = false;
              this.$router.push({ path: "/center" });
              loading.close();
              if (res.data.userRole == "4") {
                this.$alert(
                  "你现在已经是认证制作人，请前往认证制作人管理后台",
                  "提示",
                  {
                    confirmButtonText: "前往",
                    callback: (action) => {
                      window.open("https://admin.richandyoung.cn", "_blank");
                      //window.location.href = 'https://admin.richandyoung.cn'
                    },
                  }
                );
              }
            })
            .catch(() => {
              this.loading = false;
              loading.close();
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
  },
};
</script>

<style scoped lang="scss">
.index {
  width: 1200px;
  height: auto;
  margin: 40px auto;
  .productions {
    display: flex;
    .mile_Productions {
      width: 840px;
      img {
        width: 100%;
      }
      h3 {
        font-size: 34px;
      }
      div {
        line-height: 1;
        color: #a3f310;
        font-size: 86px;
      }
    }
  }
  .login {
    width: 296px;
    height: 410px;
    background-color: #fff;
    color: #000;
    position: relative;
    font-family: Tahoma, Arial, "Helvetica Neue", "Hiragino Sans GB", Simsun,
      sans-self;
    margin-left: 65px;
    .qcode {
      a:hover {
        text-decoration: underline;
      }
    }
    .title {
      width: 250px;
      height: 40px;
      background: #a3f310;
      border-radius: 10px;
      font-size: 18px;
      text-align: center;
      line-height: 40px;
      margin: 30px auto 30px auto;
      color: #fff;
    }
    .svg-container {
      position: absolute;
      left: 8px;
      z-index: 1;
      line-height: 42px;
    }
    .switch {
      margin: 0 auto;
      width: 110px;
      height: 30px;
      text-align: center;
      color: #a3f310;
      cursor: pointer;
    }
    .sx {
      width: 18px;
      height: 18px;
      verticalalign: middle;
      cursor: pointer;
      transition: all 0.5s;
    }
    img {
      width: 20px;
      height: 20px;
      vertical-align: sub;
    }
  }
}
.foot-bg {
  margin-top: 20px;
  width: 200px;
  img {
    width: 100%;
  }
}
</style>
<style lang="scss">
.index {
  .el-input__inner {
    padding-left: 35px;
    font-family: Tahoma, Arial, "Helvetica Neue", "Hiragino Sans GB", Simsun,
      sans-self;
    text-indent: 0.5em;
  }
  .el-form-item {
    margin-bottom: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/index.vue